import {
  changeMultiFacet,
  setAdditionalQueryParams
} from "../../state/modules/search/actions";
import {
  getFacets,
  getAdditionalQueryParams
} from "../../state/modules/search/selectors";
import { getFloorIdByGender } from "asos-site-chrome-store-presentation";
import { UNISEX_FLOOR } from "../../state/modules/page/constants";
import { getIsSearchPage } from "../../state/modules/page/selectors";
import resetAdditionalQueryParams from "../../state/modules/search/resetAdditionalQueryParams";
import {
  shouldApplyFloorFilters,
  buildFloorFacetSelections,
  getFloorFiltersForNewSearch,
  getResolvedFloor,
  hasFloorFilters,
  isFilteringExperimentEnabled
} from "./experimentFloorFilters";

export { getFloorFiltersForNewSearch };

const hasCorrectFloorFilters = (floorFacet, floorId) => {
  const expectedFloorIds = [String(floorId), String(UNISEX_FLOOR)];
  const selectedFloorIds = floorFacet.facetValues
    .filter(fv => fv.isSelected)
    .map(fv => String(fv.id));

  return (
    expectedFloorIds.every(id => selectedFloorIds.includes(id)) &&
    selectedFloorIds.length === expectedFloorIds.length
  );
};

const applyFloorFiltersWhenNoFacet = (dispatch, floorId, existingRefine) => {
  if (existingRefine && hasFloorFilters(existingRefine)) {
    dispatch(setAdditionalQueryParams({ refine: existingRefine }));

    return;
  }
  const params = { refine: `floor:${floorId},${UNISEX_FLOOR}` };
  dispatch(setAdditionalQueryParams(params));
};

const applyFloorFiltersWhenFacetExists = (dispatch, floorFacet, floorId) => {
  if (hasCorrectFloorFilters(floorFacet, floorId)) {
    return;
  }

  const facetsToSelect = buildFloorFacetSelections(floorFacet, floorId);

  if (facetsToSelect.length > 0) {
    dispatch(changeMultiFacet(facetsToSelect));
  }
};

export const setupExperiments = (store, decisions, location) => {
  const { dispatch, getState } = store;
  const state = getState();

  const urlParams = new URLSearchParams(
    location?.search || window?.location?.search || ""
  );
  const urlRefine = urlParams.get("refine");

  if (!isFilteringExperimentEnabled(decisions)) {
    return;
  }

  if (!getIsSearchPage(state)) {
    resetAdditionalQueryParams(dispatch, state, "refine");

    return;
  }

  const floor = getResolvedFloor(state);
  const floorId = getFloorIdByGender(floor);

  if (!floorId) {
    return;
  }

  const additionalQueryParams = getAdditionalQueryParams(state);
  const facets = getFacets(state);
  const floorFacet = facets.find(f => f.id === "floor");

  if (hasFloorFilters(urlRefine)) {
    dispatch(setAdditionalQueryParams({ refine: urlRefine }));

    if (floorFacet) {
      applyFloorFiltersWhenFacetExists(dispatch, floorFacet, floorId);
    }

    return;
  }

  if (!shouldApplyFloorFilters(state, additionalQueryParams)) {
    return;
  }

  if (!floorFacet) {
    applyFloorFiltersWhenNoFacet(dispatch, floorId, urlRefine);
  } else {
    applyFloorFiltersWhenFacetExists(dispatch, floorFacet, floorId);
  }
};
